import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import { Link, useParams } from "react-router-dom";
import Footer from "../../components/Footer";
import lenovo_logo from "../../assets/images/company/lenovo-logo.png";
import JobDetailComp from "../../components/job-detail-comp";
import {
  Book,
  Briefcase,
  Clock,
  DollarSign,
  MapPin,
  Monitor,
  UserCheck,
} from "react-feather";
import {
  PiMapPin,
  MdOutlineArrowForward,
  HiOutlineBuildingOffice,
} from "../../assets/icons/vander";
import ExploreJob from "../../components/Explore-job";
import { jobData } from "../../data/data";
import { api } from "../..";
import { useAuth } from "../../utility/auth";
import { Loader } from "../../components/Loader";
import PremiumBanner from "../../components/Buy-premium";

export default function JobDetailTwo() {
  const params = useParams();
  const id = params.id;
  const auth = useAuth();
  console.log("PARAM>>>", id);
  const [data, setData] = useState([]);
  const [mydesc, setMydesc] = useState("");
  const [showLogin, setShowlogin] = useState(false);
  const [showLoader, setShowloader] = useState(true);

  // Function to decode HTML entities
  function decodeHtmlEntities(encodedString) {
    const txt = document.createElement("textarea");
    txt.innerHTML = encodedString;
    return txt.value;
  }
  useEffect(() => {
    const fetchDescription = async () => {
      try {
        setShowloader(true);
        const response = await fetch(`${api}/job/?job_id=${id}`, {
          method: "GET", // or 'POST' depending on your API method
          headers: {
            Authorization: `Bearer ${auth.token}`, // Adding Bearer token in the header
            "Content-Type": "application/json", // Optional, depending on your API
          },
        });
        if (response.ok) {
          const data = await response.json();
          // console.log("DATA FROM fetchDescription>>>>>", data.data);
          setData(data.data[0]);
          setMydesc(decodeHtmlEntities(data.data[0].description));
          setShowlogin(false);
          setShowloader(false);
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (error) {
        setShowlogin(true);
        setShowloader(false);
        console.error(error.message);
      }
    };

    fetchDescription();
  }, [id]);

  return (
    <>
      <Navbar navClass="justify-end" />

      <JobalertModal isOpen={showLogin} />
      {showLoader ? (
        <Loader />
      ) : (
        <section className="bg-slate-50 dark:bg-slate-800 md:py-24 py-16">
          <div className="container mt-10">
            <div className="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
              <div className="lg:col-span-8 md:col-span-6">
                <div className="md:flex items-center p-6 shadow dark:shadow-gray-700 rounded-md bg-white dark:bg-slate-900">
                  <img
                    src={data?.logo ? data?.logo : null}
                    className="rounded-full size-28 p-4 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700"
                    alt={data?.company || "not available"}
                  />

                  <div className="md:ms-4 md:mt-0 mt-6">
                    <h5 className="text-xl font-semibold">
                      {data?.company ? data?.company : "unknown"}
                    </h5>
                    <div className="mt-2">
                      <span className="text-slate-400 font-medium me-2 inline-flex items-center">
                        <HiOutlineBuildingOffice className="text-[18px] text-indigo-600 me-1" />
                        {data?.company
                          ? `${data?.company} pvt. ltd `
                          : "searching"}{" "}
                        .
                      </span>
                      <span className="text-slate-400 font-medium me-2 inline-flex items-center">
                        <PiMapPin className="text-[18px] text-indigo-600 me-1" />{" "}
                        {data?.location
                          ? `${data.location[0].address.addressCountry},${
                              data.location[0].address.addressLocality
                            } ${
                              data.location[0].address.addressRegion || ""
                            }`.trim()
                          : "Norway, Oslo"}
                      </span>
                    </div>
                  </div>
                </div>

                <h5 className="text-lg font-semibold mt-6">Job Description:</h5>

                {/* <p className="text-slate-400 mt-4">{data.description}</p> */}

                <div>
                  {/* Render the HTML content using dangerouslySetInnerHTML */}
                  <div dangerouslySetInnerHTML={{ __html: mydesc }} />
                  <div className="mt-5">
                    <a
                      href={data.jobUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn rounded-md bg-indigo-600 hover:bg-indigo-700 border-emerald-600 hover:border-emerald-700 text-white md:ms-2 w-full md:w-auto"
                    >
                      Apply Now
                    </a>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-4 md:col-span-6">
                <div className="shadow dark:shadow-gray-700 rounded-md bg-white dark:bg-slate-900 sticky top-20">
                  <div className="p-6">
                    <h5 className="text-lg font-semibold">Job Information</h5>
                  </div>
                  <div className="p-6 border-t border-slate-100 dark:border-t-gray-700">
                    <ul className="list-none">
                      <li className="flex items-center">
                        <UserCheck className="size-5"></UserCheck>

                        <div className="ms-4">
                          <p className="font-medium">Employee Type:</p>
                          <span className="text-indigo-600 font-medium text-sm">
                            {data?.jobtype ? data?.jobtype : "Full Time"}
                          </span>
                        </div>
                      </li>

                      <li className="flex items-center mt-3">
                        <MapPin className="size-5"></MapPin>

                        <div className="ms-4">
                          <p className="font-medium">Location:</p>
                          <span className="text-indigo-600 font-medium text-sm">
                            {data?.location
                              ? data?.location[0].address.addressCountry
                              : "Australia"}
                          </span>
                        </div>
                      </li>

                      <li className="flex items-center mt-3">
                        <Monitor className="size-5"></Monitor>

                        <div className="ms-4">
                          <p className="font-medium">Job Type:</p>
                          <span className="text-indigo-600 font-medium text-sm">
                            {data?.name
                              ? data?.name
                              : "Web Designer / Developer"}
                          </span>
                        </div>
                      </li>

                      <li className="flex items-center mt-3">
                        <Briefcase className="size-5"></Briefcase>

                        <div className="ms-4">
                          <p className="font-medium">Experience:</p>
                          <span className="text-indigo-600 font-medium text-sm">
                            2+ years
                          </span>
                        </div>
                      </li>

                      {/* <li className="flex items-center mt-3">
                      <Book className="size-5"></Book>

                      <div className="ms-4">
                        <p className="font-medium">Qualifications:</p>
                        <span className="text-indigo-600 font-medium text-sm">
                          MCA
                        </span>
                      </div>
                    </li> */}

                      <li className="flex items-center mt-3">
                        <DollarSign className="size-5"></DollarSign>

                        <div className="ms-4">
                          <p className="font-medium">Salary:</p>
                          <span className="text-indigo-600 font-medium text-sm">
                            {data?.salary
                              ? data?.salary
                              : "Check through apply button"}
                          </span>
                        </div>
                      </li>

                      <li className="flex items-center mt-3">
                        <Clock className="size-5"></Clock>

                        <div className="ms-4">
                          <p className="font-medium">Date posted:</p>
                          <span className="text-indigo-600 font-medium text-sm">
                            {new Date(data.created_at).toLocaleDateString(
                              "en-US",
                              { year: "numeric", month: "long", day: "numeric" }
                            )}
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <ExploreJob />
      <br />
      <br />
      <Footer />
      <PremiumBanner />
    </>
  );
}

export const JobalertModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null; // Don't render if modal is not open

  return (
    <div
      className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 backdrop-blur-sm z-50"
      onClick={onClose} // Close modal when clicking outside of it
    >
      <div
        className="flex  flex-col gap-5 bg-white p-6 rounded-lg shadow-xl w-1/3"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <p className="text-lg">Please login/signup to view job details </p>
        <button
          onClick={() => {
            window.location.href = "/login";
          }}
          className="  bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-400"
        >
          Login
        </button>
      </div>
    </div>
  );
};

// {/* <JobDetailComp /> */}
